'use client';

/* ปุ่มทางเข้าบนแถบลอย — ขอลิงก์เข้าเล่นจากหลังบ้านแล้วเปิดเลย
   ยังไม่ล็อกอิน = เปิดกล่องเข้าสู่ระบบให้ก่อน */

import { useState } from 'react';
import { requestGame } from '../lib/gameNavigation';
import toast from '../lib/toast';
import { getToken, launchGame } from '../lib/auth';

export default function QbarEnter({ children }) {
  const [busy, setBusy] = useState(false);

  const enter = async (e) => {
    e.preventDefault();
    if (!getToken()) {
      document.querySelector('[data-auth]:not([data-auth="register"])')?.click();
      return;
    }
    if (busy) return;
    setBusy(true);
    try { await requestGame(async (signal) => {
      const url = await launchGame(undefined, {}, signal);
      return url;
    }); } finally { setBusy(false); }
  };

  return (
    <a className={`qbar-main${busy ? ' busy' : ''}`} href="/setting-dns" onClick={enter}>{children}</a>
  );
}
